/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Leveling_HeadlineInputs */



/**
* | output |
* | --- |
* | "Levels that know your server." |
*
* @param {Products_Leveling_HeadlineInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_headline = /** @type {((inputs?: Products_Leveling_HeadlineInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_HeadlineInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Уровни, которые знают ваш сервер.")
	return /** @type {LocalizedString} */ ("Levels that know your server.")
});